module.exports = __webpack_public_path__ + "static/img/12.c4165e9.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/5/1/zh/12.png
// module id = Pxf1
// module chunks = 0